const article = {
  id: "nakrutka-proslushivaniy-pravila-distributorov",
  metaTitle: "Накрутка прослушиваний: правила дистрибьюторов | Boostclick",
  metaDescription: "Что на самом деле грозит за искусственные прослушивания: правила TuneCore, Amuse и DistroKid, позиция российских площадок и ответственность за чужие действия.",
  type: "Гайд",
  category: "Музыка",
  title: "Что бывает за накрутку прослушиваний: правила дистрибьюторов",
  time: 7,
  data: "31.07.2026",
  imageUrl: "/blogImages/nakrutka-proslushivaniy-pravila-distributorov/backgroundImage.svg",
  hasDescriptionHeader: true,
  description: `Разбор по первоисточникам: где в правилах дистрибьюторов
  написано про искусственные прослушивания, у кого денежный штраф, а у кого
  только удаление релиза, почему ответственность наступает даже за чужие
  действия и что российские площадки делают вместо блокировок.`,
  navigation: [
    { to: "kto-nakazyvaet", text: "Наказывает не площадка" },
    { to: "tunecore", text: "TuneCore" },
    { to: "amuse", text: "Amuse" },
    { to: "distrokid", text: "DistroKid" },
    { to: "rossiyskie", text: "Российские площадки" },
    { to: "chuzhaya-nakrutka", text: "Ответственность за чужие действия" },
    { to: "chto-vydaet", text: "Что выдаёт искусственные прослушивания" },
    { to: "chto-delat", text: "Что делать, если уже заказали" },
    { to: "korotko", text: "Коротко" },
  ],
  section: [
    {
      id: "kto-nakazyvaet",
      title: "Наказывает не площадка, а дистрибьютор",
      content: [
        {
          type: "Description",
          parts: [
            "Распространённое заблуждение: артисты боятся санкций Яндекс Музыки. Но в ",
            { href: "https://yandex.ru/support/music/ru/rules", text: "правилах размещения контента" },
            " и в ",
            { href: "https://yandex.ru/legal/music_termsofuse/index.html", text: "условиях использования сервиса" },
            " пунктов про накрутку нет вообще — там регулируются авторские права, шок-контент и ИИ-контент.",
          ],
        },
        {
          type: "Description",
          text: "Реальные последствия приходят с другой стороны — от дистрибьютора, через которого выпущен релиз. Именно у него в договоре прописаны и удаление трека, и невыплата роялти, и денежные штрафы. Это важно понимать до того, как соглашаться на «безопасную накрутку»: безопасность здесь определяется не площадкой, а тем документом, который вы подписали при загрузке релиза.",
        },
        {
          type: "Subtotal",
          title: "Что стоит сделать до всего остального",
          text: "Открыть правила своего дистрибьютора и найти раздел про artificial streaming или streaming manipulation. Формулировки различаются сильнее, чем кажется, и разница между «удалим трек» и «спишем штраф из роялти» существенная.",
        },
      ],
    },
    {
      id: "tunecore",
      title: "TuneCore: удаление без права перезалить",
      content: [
        {
          type: "Description",
          parts: [
            "TuneCore (входит в группу Believe) описывает последствия подробнее остальных (",
            { href: "https://support.tunecore.com/hc/en-us/articles/22901710894356-Fees-Penalties-for-Artificial-Streaming", text: "Fees & Penalties for Artificial Streaming" },
            "):",
          ],
          style: { marginBottom: "8px" },
        },
        {
          type: "List",
          listType: "ul",
          items: [
            { text: "треки с высокой долей фродовых прослушиваний удаляются со всех площадок;" },
            { text: "удалённые по этой причине релизы нельзя перезалить или переиздать;" },
            { text: "аккаунт может быть закрыт полностью;" },
            { text: "штраф Spotify в размере 10 евро за трек в месяц перевыставляется владельцу аккаунта." },
          ],
        },
        {
          type: "Description",
          text: "Первый пункт обычно недооценивают: удаление трека — это не «переделаем и зальём заново». Каталог теряется, а вместе с ним накопленная у релиза история.",
        },
      ],
    },
    {
      id: "amuse",
      title: "Amuse: штраф вычитается из роялти",
      content: [
        {
          type: "Description",
          parts: [
            "У Amuse механика другая — денежная. По ",
            { href: "https://www.amuse.io/en/resources/terms-of-use/", text: "условиям использования" },
            ": штраф 10 евро за запись в месяц, применяется без предварительного уведомления и вычитается из роялти.",
          ],
        },
        {
          type: "Description",
          text: "Дальше начинается неприятное. Если сумма штрафов превышает накопленные роялти, баланс уходит в минус, и выплаты блокируются до погашения — за счёт будущих поступлений. Перезалить удалённый релиз можно не раньше чем через 30 дней.",
        },
        {
          type: "Footnote",
          textItalic: "То есть заплатить придётся дважды: сначала за саму накрутку, потом штрафом из тех денег, которые релиз ещё не заработал.",
        },
      ],
    },
    {
      id: "distrokid",
      title: "DistroKid: без штрафов, но с удалением",
      content: [
        {
          type: "Description",
          parts: [
            "DistroKid денежных штрафов в справке не заявляет, и это важное отличие: тексты, где «DistroKid штрафует на 10 евро», просто переносят условия других сервисов. Что заявлено (",
            { href: "https://support.distrokid.com/hc/en-us/articles/360013647373-What-is-Artificial-Streaming", text: "What is Artificial Streaming" },
            "): при существенной доле искусственных прослушиваний трек удаляется, роялти с таких прослушиваний не выплачиваются, аккаунт может быть закрыт.",
          ],
        },
        {
          type: "Description",
          parts: [
            "Позиция самой стриминговой площадки тоже описана публично — Spotify держит ",
            { href: "https://artists.spotify.com/ru/artificial-streaming", text: "отдельный раздел про искусственные прослушивания" },
            " для артистов.",
          ],
        },
        {
          type: "Subtotal",
          title: "Вывод из трёх примеров",
          text: "Общее у всех — удаление релиза и невыплата роялти. Различается денежная часть: где-то штраф есть, где-то его нет. Ориентироваться нужно на документ своего дистрибьютора, а не на пересказ в статьях.",
        },
      ],
    },
    {
      id: "rossiyskie",
      title: "Российские площадки: обнуление вместо блокировки",
      content: [
        {
          type: "Description",
          parts: [
            "Российские сервисы формулируют свою позицию иначе. VK Музыка: «Если наши алгоритмы обнаружат подозрительную активность какого-то трека, то подозрительные прослушивания перестают учитываться в общей статистике». Звук говорит о принципе нулевой терпимости: «как только наши детекторы показывают, что какие-то прослушивания с высокой вероятностью были накручены, мы их обнуляем» (",
            { href: "https://i-m-i.ru/post/cheating-on-charts", text: "ИМИ.Журнал" },
            ").",
          ],
        },
        {
          type: "Description",
          text: "Логика та же, что и в поисковых системах: искусственная активность чаще не наказывается, а просто перестаёт учитываться. Для артиста это худший из сценариев — деньги потрачены, цифры в статистике какое-то время есть, алгоритмического эффекта нет и не будет.",
        },
      ],
    },
    {
      id: "chuzhaya-nakrutka",
      title: "Ответственность за чужие действия",
      content: [
        {
          type: "Description",
          text: "Самый неприятный пункт в правилах TuneCore: ответственность наступает, даже если накрутку заказали не вы. Дословно — «You are liable for Streaming Manipulation perpetrated by a third party on your behalf», то есть за действия третьего лица, совершённые в ваших интересах.",
        },
        {
          type: "Description",
          parts: [
            "Практических следствий два. Первое: если продвижением занимается подрядчик, отвечать перед дистрибьютором будете вы, а не он. Второе: известны случаи, когда артисты теряли каталог из-за активности, которую не заказывали (",
            { href: "https://variety.com/2024/music/news/spotify-artists-streaming-fraud-1235965379/", text: "Variety, 2024" },
            ").",
          ],
        },
        {
          type: "Subtotal",
          title: "Что из этого следует",
          text: "Спрашивайте подрядчика, что именно он делает, и требуйте отчётность, которую можно проверить. «Мы просто продвигаем» — не ответ, за который дистрибьютор снимет с вас ответственность.",
        },
      ],
    },
    {
      id: "chto-vydaet",
      title: "Что выдаёт искусственные прослушивания",
      content: [
        {
          type: "Description",
          text: "TuneCore перечисляет в качестве признаков: аномально высокие или нерегулярные паттерны прослушиваний, прослушивания из регионов, где у артиста нет аудитории, подозрительные размещения в плейлистах и необъяснимые всплески. Там же — простое наблюдение: живые слушатели спят и делают перерывы, а автоматика работает круглосуточно без пауз.",
        },
        {
          type: "Description",
          text: "Есть признак, который артист видит у себя в кабинете сам, без всяких детекторов: много прослушиваний при нулевом числе суперфанов и нулевых лайках. В аналитике BandLink обе метрики выведены отдельно, и расхождение между ними бросается в глаза на следующий же день.",
        },
        {
          type: "Description",
          parts: [
            "Разница с заданиями живым слушателям здесь не в маскировке, а в природе действия: человек открывает приложение со своего аккаунта, находит трек, слушает его, ставит лайк, заходит к другим трекам — то есть делает то же, что делал бы любой слушатель. Как устроены такие сценарии, описано на странице ",
            { to: "/prodvizhenie-trekov-yandexmusic", text: "заданий живым слушателям в Яндекс Музыке" },
            ".",
          ],
        },
      ],
    },
    {
      id: "chto-delat",
      title: "Что делать, если вы это уже заказали",
      content: [
        {
          type: "List",
          listType: "ol",
          items: [
            { bold: "Остановить кампанию. ", text: "Продолжение увеличивает долю искусственных прослушиваний, а именно на долю смотрят детекторы." },
            { bold: "Открыть правила своего дистрибьютора. ", text: "Понять, что вам грозит по документу: штраф, удаление или закрытие аккаунта." },
            { bold: "Посмотреть на статистику честно. ", text: "Соотношение прослушиваний к лайкам и суперфанам покажет, насколько заметен перекос." },
            { bold: "Не пытаться «разбавить». ", text: "Добавление ещё большего объёма поверх — самая частая и самая дорогая ошибка." },
            { bold: "Дальше работать на живую реакцию. ", text: "Она восстанавливает соотношения, которых не хватает, — а именно соотношения, а не абсолютные числа, и смотрят и площадки, и алгоритм рекомендаций." },
          ],
        },
        {
          type: "Description",
          parts: [
            "Что вообще влияет на рекомендации и на что стоит тратить силы вместо объёма — разобрано в статье про ",
            { to: "/blog/kak-popast-v-moyu-volnu", text: "попадание в «Мою волну»" },
            ".",
          ],
        },
      ],
    },
    {
      id: "korotko",
      title: "Коротко",
      content: [
        {
          type: "List",
          listType: "ul",
          items: [
            { text: "В правилах Яндекс Музыки пунктов про накрутку нет — санкции приходят от дистрибьютора." },
            { text: "TuneCore: удаление со всех площадок без права перезалить, возможное закрытие аккаунта, перевыставление штрафа Spotify." },
            { text: "Amuse: 10 евро за запись в месяц из роялти, без предупреждения, с уходом баланса в минус." },
            { text: "DistroKid: денежных штрафов не заявляет, но удаляет трек и не выплачивает роялти." },
            { text: "VK Музыка и Звук не банят, а обнуляют подозрительные прослушивания — деньги потрачены, эффекта нет." },
            { text: "Ответственность наступает и за накрутку, заказанную третьим лицом в ваших интересах." },
            { text: "Главный видимый признак перекоса — много прослушиваний при нулевых лайках и суперфанах." },
          ],
          classes: ["nomargin"],
        },
      ],
    },
  ],
};

export default article;
